import { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { functionService } from "../../../../lib/functions";

import styles from "../../styles/style.module.scss";

const AddBulkEmail = ({
  show,
  setShow,
  handleClose,
  emailList,
  setEmailList,
  setTrainingData,
  trainingData,
}) => {
  const [currentemail, setCurrentEmail] = useState("");

  const addEmail = async ({ email, trainingId }) => {
    let { response, status, error } = await functionService.post(
      `training/enroll`,
      {
        email,
        trainingId,
      }
    );

    if (status) {
      setEmailList([
        ...emailList,
        {
          email: currentemail,
          id: response?.data?.data?.enrolledStudent?.id,
        },
      ]);

      setTrainingData({
        ...trainingData,
        emails: [
          ...trainingData.emails,
          {
            email: currentemail,
            id: response?.data?.data?.enrolledStudent?.id,
          },
        ],
      });

      setShow(false);
      setError(false);
      setCurrentEmail("");
    } else {
      console.log(error);
    }
  };

  const [error, setError] = useState(false);

  const handleSubmit = () => {
    if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(currentemail)) {
      console.log("a");
      addEmail({
        email: currentemail,
        trainingId: trainingData.id,
      });
    } else {
      setError(true);
    }
  };

  return (
    <Modal
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={show}
      backdropClassName={styles.modalBackdrop}
      contentClassName={styles.modalContent}
      dialogClassName={styles.modalDialog}
    >
      <Modal.Body>
        <div className={styles.modalHeading}>Assign Candidates</div>
        <textarea
          className={styles.assignEmailBox}
          placeholder="Enter the email address of assign candidates"
          onChange={(e) => {
            setCurrentEmail(e.target.value);
          }}
          value={currentemail}
        />
        {error && (
          <p style={{ color: "red", fontSize: "12px" }}>Enter Valid Email</p>
        )}
        <Button
          variant="primary"
          className={styles.cancelButton}
          onClick={() => {
            setError(false);
            setCurrentEmail("");
            handleClose();
          }}
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          className={styles.assignButton}
          onClick={handleSubmit}
        >
          Assign
        </Button>
      </Modal.Body>
    </Modal>
  );
};

export default AddBulkEmail;
